import { Collapse } from 'antd';

const { Panel } = Collapse;

const CollapsiblePanel = ({
  tabs = [],
  activeKey = '1',
  handleTabClick = () => {},
  forceRender = false,
  showArrow = true,
}) => {
  return (
    <Collapse ghost className="common-collapse-container" activeKey={activeKey} onChange={handleTabClick}>
      {/* TODO: Use items instead of children. Using `children` will be removed in next major version. */}
      {tabs.map(({ header, content, hidePadding = false, tabKey = false }, idx) => (
        <Panel
          header={header}
          key={tabKey ? tabKey : idx + 1}
          id={tabKey ? tabKey : idx + 1}
          forceRender={forceRender}
          className={hidePadding ? 'padding-none' : ''}
          showArrow={showArrow}
        >
          {content}
        </Panel>
      ))}
    </Collapse>
  );
};

export default CollapsiblePanel;
